module.exports = __webpack_public_path__ + "img/medicine-ill.6a72f038.svg";